
































































import { defineComponent, reactive, ref, watch, computed, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import upgradeDialog from '@/renderer/scripts/utils/upgradeDialog';
import closeVersionDialog from './components/closeVersionDialog.vue';
export default defineComponent({
  components: {
    closeVersionDialog,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    // 非企业版屏蔽功能按钮
    const featureNotSupported = computed(() => store.getters.editionFlag !== 'enterprise');
    // 历史版本最大限制
    const maxFileHistoryCount = computed(() => (featureNotSupported.value ? 20 : 1000));

    const formData = reactive({
      enableFileHistory: false,
      fileHistoryCount: 0,
      fileHistoryExpireDay: featureNotSupported.value ? 0 : 30,
    });
    const remoteData = reactive({
      enableFileHistory: false,
      fileHistoryCount: 0,
      fileHistoryExpireDay: featureNotSupported.value ? 0 : 30,
    });
    const countNoLimit = ref(!featureNotSupported.value);
    const timeNoLimit = ref(featureNotSupported.value);
    const options: any[] = [
      {
        label: i18n_t('3天'),
        value: 3,
      },
      {
        label: i18n_t('7天'),
        value: 7,
      },
      {
        label: i18n_t('14天'),
        value: 14,
      },
      {
        label: i18n_t('30天'),
        value: 30,
      },
      {
        label: i18n_t('90天'),
        value: 90,
      },
      {
        label: i18n_t('半年'),
        value: 180,
      },
      {
        label: i18n_t('1年'),
        value: 360,
      },
      {
        label: i18n_t('2年'),
        value: 720,
      },
      {
        label: i18n_t('3年'),
        value: 1080,
      },
      {
        label: i18n_t('永久'),
        value: 0,
      },
    ];
    const showCloseDialog = ref(false);
    const countDisabled = computed(
      () =>
        !countNoLimit.value && (!formData.fileHistoryCount || formData.fileHistoryCount > maxFileHistoryCount.value),
    );
    const saveDisabled = computed(() => {
      const notChanged =
        remoteData.enableFileHistory === formData.enableFileHistory &&
        remoteData.fileHistoryCount === formData.fileHistoryCount &&
        +remoteData.fileHistoryExpireDay === +formData.fileHistoryExpireDay;
      return notChanged || countDisabled.value;
    });
    const methods = {
      async getConfig() {
        try {
          tips.loading(i18n_t('正在获取版本配置信息'));
          const res = await smh.userAPI.getLibraryHistoryExtension();
          tips.closeAll();
          const { enableFileHistory, fileHistoryCount = 0, fileHistoryExpireDay = 0 } = res.data;
          Object.assign(remoteData, {
            enableFileHistory,
            fileHistoryCount,
            fileHistoryExpireDay,
          });
          Object.assign(formData, {
            enableFileHistory,
            fileHistoryCount,
            fileHistoryExpireDay,
          });
        } catch (e) {
          tips.error(i18n_t('获取版本配置信息失败'));
        }
      },
      async setConfig() {
        const params = {
          ...formData,
          fileHistoryExpireDay: +formData.fileHistoryExpireDay,
        };
        try {
          tips.loading(i18n_t('正在设置版本配置信息'));
          await smh.userAPI.setVersionConfig(params);
          tips.success(i18n_t('设置成功'));
          Object.assign(remoteData, params);
        } catch (e) {
          tips.error(i18n_t('设置版本配置信息失败'));
        }
      },
      // 确认关闭历史版本
      async closeVersion(isClearFileHistory: boolean) {
        try {
          tips.loading(i18n_t('正在设置版本配置信息'));
          await smh.userAPI.setVersionConfig({
            enableFileHistory: false,
            isClearFileHistory,
          });
          tips.success(i18n_t('设置成功'));
          showCloseDialog.value = false;
          formData.enableFileHistory = false;
          remoteData.enableFileHistory = false;
        } catch (e) {
          tips.error(i18n_t('设置版本配置信息失败'));
        }
      },
      // 取消关闭历史版本
      cancelClose() {
        formData.enableFileHistory = true;
      },
      countNoLimitChange(val: boolean) {
        // 非企业版必须限制版本数
        if (val && featureNotSupported.value) {
          countNoLimit.value = false;
          upgradeDialog.show({
            source: 'history_numbers_limit',
            header: i18n_t('历史版本数量达到上限'),
            body: i18n_t('当前版本可设置至多20个历史版本，升级企业版即可不限历史版本数量，记录每一次文件变更'),
          });
        }
      },
      timeNoLimitChange(val: boolean) {
        // 非企业版限制版本生命周期为永久
        if (!val && featureNotSupported.value) {
          timeNoLimit.value = true;
          upgradeDialog.show({
            source: 'history_auto_delete_limit',
            header: i18n_t('暂不支持版本生命周期'),
            body: i18n_t(
              '当前版本暂不支持设置历史版本生命周期，升级企业版即可设置历史版本到期自动删除，减少手动维护成本',
            ),
          });
        }
      },
    };
    methods.getConfig();
    watch(
      () => countNoLimit.value,
      val => {
        if (val) {
          Object.assign(formData, {
            fileHistoryCount: 0,
          });
        } else {
          // eslint-disable-next-line max-len
          Object.assign(formData, {
            fileHistoryCount: remoteData.fileHistoryCount === undefined ? 5 : remoteData.fileHistoryCount,
          });
        }
      },
    );
    watch(
      () => timeNoLimit.value,
      val => {
        if (val) {
          Object.assign(formData, {
            fileHistoryExpireDay: 0,
          });
        } else {
          // eslint-disable-next-line max-len
          Object.assign(formData, {
            fileHistoryExpireDay: remoteData.fileHistoryExpireDay === undefined ? 30 : remoteData.fileHistoryExpireDay,
          });
        }
      },
    );
    watch(
      () => formData.fileHistoryCount,
      (val, old) => {
        // 非企业版限制版本上限为20
        if (featureNotSupported.value) {
          if (formData.fileHistoryCount > maxFileHistoryCount.value || formData.fileHistoryCount === 0) {
            formData.fileHistoryCount = old;
            upgradeDialog.show({
              source: 'history_numbers_limit',
              header: i18n_t('历史版本数量达到上限'),
              body: i18n_t('当前版本可设置至多20个历史版本，升级企业版即可不限历史版本数量，记录每一次文件变更'),
              finally() {
                formData.fileHistoryCount = old;
              },
            });
          }
        }
      },
    );
    watch(formData, val => {
      countNoLimit.value = formData.fileHistoryCount === 0;
      timeNoLimit.value = formData.fileHistoryExpireDay === 0;
    });
    watch(
      () => formData.enableFileHistory,
      (newVal, oldVal) => {
        if (oldVal && !newVal) {
          // 关闭历史版本
          showCloseDialog.value = true;
        } else {
          // 打开历史版本 恢复远端设置
          Object.assign(formData, {
            fileHistoryCount: remoteData.fileHistoryCount,
            fileHistoryExpireDay: featureNotSupported.value ? 0 : remoteData.fileHistoryExpireDay,
          });
        }
      },
    );
    watch(
      () => featureNotSupported.value,
      val => {
        if (val) {
          countNoLimit.value = false;
          timeNoLimit.value = true;
        }
      },
    );
    return {
      remoteData,
      formData,
      countNoLimit,
      timeNoLimit,
      options,
      saveDisabled,
      showCloseDialog,
      ...methods,
    };
  },
});
